<template>
    <div>
        <button
            type="button"
            class="w-full flex items-center gap-3 px-4 py-3 text-sm text-theme-base hover:bg-theme-hover transition-colors"
            @click="isOpen = !isOpen"
        >
            <span class="flex-1 flex items-center gap-3 truncate">
                <slot name="header"></slot>
            </span>
            <chevron-down-icon
                :class="[
                    'w-4 h-4 flex-shrink-0 transition-transform',
                    isOpen ? 'rotate-180' : ''
                ]"
            />
        </button>
        <custom-collapse :visible="isOpen">
            <slot></slot>
        </custom-collapse>
    </div>
</template>

<script>
import ChevronDownIcon from "@/components/icons/ChevronDownIcon.vue";
import CustomCollapse from "@/components/utils/CustomCollapse.vue";

export default {
    name: "SidebarGroup",
    components: { ChevronDownIcon, CustomCollapse },
    props: {
        open: { type: Boolean, default: false }
    },
    data() {
        return { isOpen: this.open };
    }
};
</script>
